import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import withTranslation from 'next-translate/withTranslation'
import Trans from 'next-translate/Trans'
import { getUserTypes } from 'SRC/modules/common/selectors'
import { getPackages, getDiscounts, getSelectedPackage } from 'SRC/modules/users/packages/selectors'
import { setSelectedPackage, fetchPackageCategories } from 'SRC/modules/users/packages/actions'
import { PackageCategories } from '../../../../../../packages/components'
import { getCurrentUsertype } from '../../../../../selectors'
import { getListings } from 'SRC/modules/ads/lisitings/selectors'
import {
  Head,
  AdLimit,
  Listing,
  Search,
  // LocationOnMap,
  PaidLimit,
  // LocationLimit,
  // PhotoLimit,
  PaidBonusAdsPrice,
  Price,
  // Discount,
  ChoosePackage,
  ProAvailable,
  SelectedPackage
} from '../Rows'
import config from 'SRC/config/config.json'

export class Container extends React.Component {
  constructor(props) {
    super(props)

    this.defaultPackage = 2
    this.state = {
      showPackageCategories: false
    }
  }

  componentDidMount() {
    const { selectedPackage, fetchPackageCategories } = this.props
    // if (!this.props.selectedPackage) {
    //   this.props.setSelectedPackage(this.defaultPackage)
    // }
    if (selectedPackage) {
      fetchPackageCategories(selectedPackage)
    }
  }

  componentDidUpdate(prevProps) {
    const { selectedPackage, fetchPackageCategories } = this.props
    // if (!this.props.selectedPackage) {
    //   this.props.setSelectedPackage(this.defaultPackage)
    // }

    if (prevProps.selectedPackage) {
      if (prevProps.selectedPackage !== selectedPackage) {
        fetchPackageCategories(selectedPackage)
      }
    }
  }

  onPackageChange = e => {
    const id = Number(e.target.dataset.id)
    this.setSelectedPackage(id)
  }

  setSelectedPackage = selectedPackage => {
    this.props.setSelectedPackage(selectedPackage)
  }

  getSelectedPackageName() {
    const selectedPackage = this.props.packages.find(p => p.id === this.props.selectedPackage)
    if (selectedPackage) return selectedPackage.name
    return null
  }

  isServiceProvider = () => this.props.currentUserType && this.props.currentUserType.seo === config.userTypes.serviceProviderSeo

  isFreeUser = () => this.props.currentUserType && this.props.currentUserType.seo === config.userTypes.freeUserTypeSeo

  showPackageCategories = () => this.setState({ showPackageCategories: true })

  hidePackageCategories = () => this.setState({ showPackageCategories: false })

  render() {
    const isServiceProvider = this.isServiceProvider()
    const isFreeUser = this.isFreeUser()
    const userName = this.props.currentUserType && this.props.currentUserType.namePlu
    const {
      packages,
      bonusAdsPriceCost,
      selectedPackage,
      isSelectionDisabled,
      i18n: { t }
    } = this.props

    const pricePDVText = config.registrationForm.package.pricePDV
    const showPackageCategoriesButtonText = config.registrationForm.package.showPackageCategoriesButton

    return Array.isArray(packages) && packages.length ? (
      <div className='registracija-table'>
        <table className='tabela-izabrano'>
          <tbody>
            <Head packages={packages} />
            <AdLimit packages={packages} />
            {!isFreeUser ? <Listing packages={packages} userType={userName} /> : null}
            {!isFreeUser ? <Search packages={packages} /> : null}
            {!isFreeUser && !isServiceProvider ? <PaidLimit packages={packages} /> : null}
            {!isFreeUser && !isServiceProvider ? <PaidBonusAdsPrice packages={packages} cost={bonusAdsPriceCost} /> : null}
            {isFreeUser ? <ProAvailable packages={packages} /> : null}
            <Price packages={packages} />
            {
              isSelectionDisabled
                ? <SelectedPackage packages={packages} selectedPackage={selectedPackage} />
                : <ChoosePackage
                  packages={packages}
                  onChangePackage={this.onPackageChange}
                  selectedPackage={selectedPackage}
                />
            }
          </tbody>
        </table>

        <Trans
          i18nKey='common:packages_pdv_text'
          components={{
            p: <p />,
            strong: <strong />
          }}
          defaultTrans='<p>- Cijene su izražene bez <strong>PDV</strong>-a</p>'
        />

        {this.props.selectedPackage && this.props.page === 'registration'
          ? <button onClick={this.showPackageCategories}>
            {t(`common:${showPackageCategoriesButtonText[0]}`)} {this.getSelectedPackageName()} {t(`common:${showPackageCategoriesButtonText[1]}`)}
          </button> : null}
        <br />
        <PackageCategories show={this.state.showPackageCategories} onClose={this.hidePackageCategories}
          page={this.props.page} />
      </div>
    ) : null
  }
}

const mapStateToProps = (state, ownProps) => ({
  packages: getPackages(state).sort((a, b) => a.price - b.price),
  userTypes: getUserTypes(state),
  discounts: getDiscounts(state),
  bonusAdsPriceCost: getListings(state).reduce((acc, currentValue) => acc > currentValue.price ? acc : currentValue.price, 0),
  currentUserType: ownProps.currentUserType || getCurrentUsertype(state),
  selectedPackage: getSelectedPackage(state)
})

Container.propTypes = {
  packages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    visible: PropTypes.bool.isRequired,
    price: PropTypes.number
  })).isRequired,
  userTypes: PropTypes.array.isRequired,
  bonusAdsPriceCost: PropTypes.number,
  currentUserType: PropTypes.shape({
    seo: PropTypes.string.isRequired,
    namePlu: PropTypes.string.isRequired,
    parent: PropTypes.number
  }),
  setSelectedPackage: PropTypes.func.isRequired,
  fetchPackageCategories: PropTypes.func.isRequired,
  selectedPackage: PropTypes.number,
  isSelectionDisabled: PropTypes.bool.isRequired,
  page: PropTypes.string.isRequired
}

Container.defaultProps = {
  discounts: [],
  packages: [],
  isSelectionDisabled: false
}

Container.displayName = 'Package'

const enhance = compose(
  withTranslation,
  connect(mapStateToProps, {
    setSelectedPackage,
    fetchPackageCategories
  })
)

export default enhance(Container)
